import React, { PropTypes } from 'react';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { routerShape } from 'react-router';
import { bindActionCreators } from 'redux';

import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { Layout, MainContent, Sidebar } from '@bibliocommons/base-drawer';
import { libraryShape, accountShape } from '@bibliocommons/bc-prop-types';

import DrawerActions from '../../../../actions/DrawerActions';
import MessagesActions from '../../../../actions/MessagesActions';

import { currentLibrarySelector } from '../../../../selectors/LibrarySelector';
import { getSummary, getBorrowingHistorySummary } from '../../../../selectors/BorrowingSelector';
import { currentAccountSelector, getAccountsByLibraryId } from '../../../../selectors/AuthSelector';

import MyBorrowingSidebar from '../../sidebar/MyBorrowingSidebar';
import BorrowingSidebarToggleButton from '../../sidebar/BorrowingSidebarToggleButton';
import AccountSwitcherContainer from '../../../../containers/AccountSwitcherContainer';

import { getILSQuotas } from '../../../../selectors/HoldsSelector';
import BorrowingOptIn from '../BorrowingOptIn';

import './BorrowingLayout.scss';

const getActiveSection = path => {
  const ctrl = path.split('/')[2];
  if ([
    'checkedout',
    'holds',
    'fines',
    'recentlyreturned',
    'interlibraryloans',
    'accountmessages'
  ].includes(ctrl)) {
    return ctrl;
  }

  return 'other';
};

export class BorrowingLayout extends BcReactComponent {
  componentDidMount() {
    const accountId = this.props.account.get('id');
    this.props.messagesActions.fetchMessages({ accountId });
  }

  render() {
    const {
      children,
      account,
      drawerActions,
      checkoutSummary,
      holdsSummary,
      totalFines,
      totalBorrowingHistory,
      messages,
      drawer,
      library,
      ILSQuotas,
      accountsByLibraryId,
      illSummary,
      router: { location }
    } = this.props;

    const active = getActiveSection(location.pathname);

    return (
      <Layout open={drawer.get('open')} containerClass="cp-borrowing-layout">
        <BorrowingOptIn location={location} />
        <Sidebar sidebarClass="borrowing-widget-sidebar" drawerActions={drawerActions}>
          <MyBorrowingSidebar
            account={account}
            drawer={drawer}
            location={location}
            activeSection={active}
            libraryName={library.get('fullName', '')}
            linkableLibraries={library.get('linkableLibraries', Immutable.List())}
            holdsSummary={holdsSummary}
            checkoutSummary={checkoutSummary}
            accountsByLibraryId={accountsByLibraryId}
            totalFines={totalFines}
            totalBorrowingHistory={totalBorrowingHistory}
            drawerActions={drawerActions}
            ILSQuotas={ILSQuotas}
            messages={messages}
            isRecentlyReturnedEnabled={library.get('recentlyReturned')}
            isIllRequestsEnabled={library.get('illRequests')}
            illSummary={illSummary}
            isAccountMessagesEnabled={library.get('accountMessages')}
            isRemainingHoldsEnabled={library.get('remainingHolds')}
            showCardExpiryDate={library.get('cardExpiryDate')} />
        </Sidebar>
        <MainContent mainClass="borrowing-content">
          <BorrowingSidebarToggleButton drawerActions={drawerActions} />
          <span className="top-accout-swticher"><AccountSwitcherContainer /></span>
          {children}
        </MainContent>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  drawer: state.get('drawer'),
  checkoutSummary: getSummary(state, 'checkedout'),
  holdsSummary: getSummary(state, 'holds'),
  totalFines: getSummary(state, 'fines').get('totalFines', 0),
  totalBorrowingHistory: getBorrowingHistorySummary(state),
  illSummary: getSummary(state, 'interlibraryLoans'),
  messages: state.getIn(['entities', 'messages']),
  account: currentAccountSelector(state),
  library: currentLibrarySelector(state),
  accountsByLibraryId: getAccountsByLibraryId(state),
  ILSQuotas: getILSQuotas(state)
});

const mapDispatchToProps = dispatch => ({
  drawerActions: bindActionCreators(DrawerActions, dispatch),
  messagesActions: bindActionCreators(MessagesActions, dispatch)
});

BorrowingLayout.propTypes = {
  account: accountShape,
  drawer: ImmutablePropTypes.mapContains({
    open: PropTypes.bool
  }).isRequired,
  checkoutSummary: ImmutablePropTypes.mapContains({
    nextDue: ImmutablePropTypes.mapContains({
      date: PropTypes.string,
      status: PropTypes.string
    }),
    status: ImmutablePropTypes.map
  }),
  holdsSummary: ImmutablePropTypes.mapContains({
    status: ImmutablePropTypes.map
  }),
  totalFines: PropTypes.number.isRequired,
  totalBorrowingHistory: PropTypes.number,
  messages: ImmutablePropTypes.map.isRequired,
  ILSQuotas: ImmutablePropTypes.map,
  drawerActions: PropTypes.objectOf(PropTypes.func).isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  library: libraryShape,
  router: routerShape,
  accountsByLibraryId: ImmutablePropTypes.mapOf(accountShape),
  messagesActions: PropTypes.objectOf(PropTypes.func)
};

export default connect(mapStateToProps, mapDispatchToProps)(BorrowingLayout);



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BorrowingLayout/BorrowingLayout.jsx